//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import calorieFree from '../../assets/images/calorieFreeTransition.png';
import styles from './style.module.scss';
import metabolismImpact from '../../assets/images/metabolism-impact.png';
import progressUnlocked from '../../assets/images/progress-unlocked.png';
import elite from '../../assets/images/elite-insight-access.png';
import dnaFace from '../../assets/images/dna-face.jpeg';
import dnaMap from '../../assets/images/dna-map.jpeg';
import getLocale from 'src/localization/get-locale';

const imageMap = {
  'calorie-free': calorieFree,
  'metabolism-impact': metabolismImpact,
  'progress-unlocked': progressUnlocked,
  'elite-insight-access': elite,
  'dna-face': dnaFace,
  'dna-map': dnaMap,
};

function DynamicTransitionImage({ pageConfig, onNext, onPrev }) {
  const { currentIndex } = useNav();
  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);
  const locale = getLocale();

  const isFirst = currentIndex === 0;

  const imageSrc = imageMap[pageConfig.id];

  const handleContinue = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: pageConfig.id,
    });
    onNext();
  };

  return (
    <div
      className={`page ${styles.top}`}
      style={showPhotoProcessing ? { marginTop: '10px' } : { marginTop: '52px' }}
    >
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className={'wrapper-info'}>
        <Title tag='h2'>{pageConfig.title[locale]}</Title>
        {pageConfig.text && (
          <Text semibold className={'description'}>
            {pageConfig.text[locale]}
          </Text>
        )}
        {pageConfig.subTitle && (
          <Text size='m' medium className='description'>
            {pageConfig.subTitle[locale]}
          </Text>
        )}
      </div>

      <div
        className={styles.image}
        style={{
          backgroundImage: `url(${imageSrc})`,
        }}
      />

      <div className={'next-wrapper'}>
        <Button onClick={handleContinue} title={t('onboarding.analyzeBody.continue')} />
      </div>
    </div>
  );
}

export default DynamicTransitionImage;
